var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h1',[_vm._v("其他用户都在租")]),_c('div',{staticClass:"content"},_vm._l((_vm.b=_vm.navList),function(item,index){return _c('nav',{class:index==_vm.active?'active':' ',on:{"click":function($event){_vm.active=index}}},[_c('li',[_vm._v(_vm._s(item.title))]),_c('li',[_vm._v(_vm._s(item.className))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }